import React, { useEffect, useMemo, useRef, useState } from 'react';

import PropTypes from 'prop-types';

// @mui
import { Typography, Box, Divider } from '@mui/material';

import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';


export default function QueueInfo (props) {

    const { track } = props
    


    return (<Card sx={{ display: 'flex', flexDirection: 'row',  mt:1, flexGrow: 2}}>

    <Box flexGrow={1} />
    <CardContent sx={{ flex: '0 0 auto', flexGrow: 2}} >
      
    <Typography component="div" variant="caption">
      NEXT UP :
      </Typography>

      <Typography component="div" variant="h4">
      {track.name}
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" component="div">
        {track.artists[0].name}
      </Typography>
      
    </CardContent>
  <CardMedia
    component="img"
    sx={{ width: '1vw', flexGrow: 1 }}
    image={track.album.images[0].url}
    alt={track.name}
  /></Card>)



}